// D:\directiveai-react\frontend\src\components\home\HomeInput\styles\MinimalStyle.js
import React from 'react';
import MinimalLayout from '../layouts/MinimalLayout';

const MinimalStyle = {
  getContainerStyles: () => ({}), // Estilos por defecto
  
  getTextFieldStyles: () => ({}), // Estilos por defecto
  
  getPromptCardStyles: () => ({}), // Estilos por defecto
  
  getStylePreviewConfig: (theme) => {
    const isWallpaperMode = theme.palette.actualMode === 'wallpaper';

    return {
      backgroundColor: isWallpaperMode
        ? 'rgba(128, 128, 128, 0.3)'
        : (theme.palette.mode === 'dark' ? '#1C1C1E' : '#F2F2F7'),
      backdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
      WebkitBackdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
      borderRadius: '28px',
      inputStyle: {
        borderRadius: '30px',
        backgroundColor: isWallpaperMode
          ? 'rgba(128, 128, 128, 0.3)'
          : (theme.palette.mode === 'dark' ? '#2C2C2E' : '#E9E9EB'),
        backdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
        WebkitBackdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
      },
      cardStyle: {
        borderRadius: '28px',
        backgroundColor: isWallpaperMode
          ? 'rgba(128, 128, 128, 0.3)'
          : (theme.palette.mode === 'dark' ? '#2C2C2E' : '#E9E9EB'),
        backdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
        WebkitBackdropFilter: isWallpaperMode ? 'blur(10px)' : 'none',
      }
    };
  },
  
  // Renderizar el layout correspondiente y pasar cualquier prop recibida, incluyendo la función de traducción
  renderLayout: (props) => <MinimalLayout {...props} />
};

export default MinimalStyle;